import Player from '@vimeo/player'; //import $ from "jquery";

$(document).ready(function () {
  var videoPlayer = new Array();
  var videoStatic = new Array();
  var scrolling = 0;
  var count = 0;
  var windowWidth = $(window).width(),
      checkScreensize = debounce(function () {
    windowWidth = $(window).width();
  }, 250);

  if ($('#group-home').length > 0) {
    var screenSize = "";
    screenSize = "mobile";
    $('#group-home').addClass('mobileLoad');
    $("#scroll-more-circle, .bottom-arrow").on('click', function () {
      fullpage_api.moveTo(2);
    });
    $(".playbutton-home").on('click', function () {
      videoOnePlay();
    });
    $(".full-video-home").each(function (index) {
      count++;
      var headerVideoContainer = $(this).find('.header_video').data('vimeo-vid');

      if (windowWidth > 767) {
        var headerVideoID = $(this).find('.header_video').data('vimeo-vid');
        videoStatic[count] = $(this).find('.page-header__image__desktop');
      } else {
        var headerVideoID = $(this).find('.header_video').data('vimeo-vid-mobile');
        videoStatic[count] = $(this).find('.page-header__image__mobile');
      }

      if (count == 1) {
        videoPlayer[count] = new Player('header_video' + headerVideoContainer, {
          url: "//player.vimeo.com/video/" + headerVideoID,
          controls: false
        });
      } else {
        videoPlayer[count] = new Player('header_video' + headerVideoContainer, {
          url: "//player.vimeo.com/video/" + headerVideoID,
          muted: true,
          controls: false
        });
      }

      videoPlayer[count].ready().then(function () {
        videoPlayer[count].pause();
      });
    });
    $(window).resize(function () {
      $(".full-video-home").each(function (index) {
        if (windowWidth > 767) {
          videoStatic[count] = $(this).find('.page-header__image__desktop');
        } else {
          videoStatic[count] = $(this).find('.page-header__image__mobile');
        }
      });
    });
    var myFullpage = new fullpage('#group-home', {
      licenseKey: 'CB341747-A0A94725-A84F4318-5EEFBDE4',
      sectionSelector: 'section',
      scrollBar: true,
      navigation: false,
      navigationPosition: 'right',
      autoScrolling: true,
      responsiveWidth: 768,
      onLeave: function (origin, destination, direction) {
        //console.log(origin.index+' '+direction);
        if (direction == 'down') {
          switch (origin.index) {
            case 0:
              videoOnePause();
              break;

            case 1:
              videoTwoPlay();
              break;

            case 2:
              videoTwoPause();
              break;

            case 4:
              videoThreePlay();
              break;

            case 8:
              videoFourPlay();
              break;

            case 9:
              videoFourPause();
              break;

            default:
              break;
          } //hamburgerColour(origin.index, direction);

        }

        if (direction == 'up') {
          switch (origin.index) {
            case 1:
              videoOnePlay();
              break;

            case 2:
              videoTwoPause();
              break;

            case 3:
              videoTwoPlay();
              break;

            case 5:
              videoThreePause();
              break;

            case 6:
              videoThreePlay();
              break;

            case 9:
              videoFourPause();
              break;

            case 10:
              videoFourPlay();
              break;

            default:
              break;
          } //hamburgerColour(origin.index, direction);

        }
      }
    });
    var whiteNavDown = [0, 1, 3, 4, 7, 8, 10];
    var whiteNavUp = [1, 2, 3, 5, 6, 9, 10, 12];

    function hamburgerColour(origin, direction) {
      if (direction == "up") {
        if (whiteNavUp.indexOf(origin) > -1) {
          $('.hamburger').removeClass('black').addClass('white');
        } else {
          $('.hamburger').removeClass('white').addClass('black');
        }
      } else if (direction == "down" || direction == "load") {
        if (whiteNavDown.indexOf(origin) > -1) {
          $('.hamburger').removeClass('black').addClass('white');
        } else {
          $('.hamburger').removeClass('white').addClass('black');
        }
      }
    } //	Video Functions


    function videoOnePlay() {
      if (scrolling != 1) {
        videoPlayer[1].play().then(function () {
          videoStatic[1].fadeOut();
          $('.playOverlay').fadeOut();
        });
        videoPlayer[1].on('ended', function () {
          videoStatic[1].fadeIn();

          if (windowWidth > 1024) {
            fullpage_api.moveTo(2);
          }
        });
      }
    }

    function videoOnePause() {
      videoStatic[1].fadeIn();
      videoPlayer[1].setCurrentTime(0).then(function (seconds) {
        videoPlayer[1].pause();
      });
    }

    function videoTwoPlay() {
      if (scrolling != 1) {
        videoPlayer[2].play().then(function () {
          videoStatic[2].fadeOut();
        });
        videoPlayer[2].on('ended', function () {
          videoStatic[2].fadeIn();

          if (screenSize == "desktop") {
            fullpage_api.moveSectionDown();
          }
        });
      }
    }

    function videoTwoPause() {
      videoStatic[2].fadeIn();
      videoPlayer[2].setCurrentTime(0).then(function (seconds) {
        videoPlayer[2].pause();
      });
    }

    function videoThreePlay() {
      if (scrolling != 1) {
        videoPlayer[3].play().then(function () {
          videoStatic[3].fadeOut();
        });
        videoPlayer[3].on('ended', function () {
          videoStatic[3].fadeIn();

          if (screenSize == "desktop") {
            fullpage_api.moveSectionDown();
          }
        });
      }
    }

    function videoThreePause() {
      videoStatic[3].fadeIn();
      videoPlayer[3].setCurrentTime(0).then(function (seconds) {
        videoPlayer[3].pause();
      });
    }

    function videoFourPlay() {
      if (scrolling != 1) {
        videoPlayer[4].play().then(function () {
          videoStatic[4].fadeOut();
        });
        videoPlayer[4].on('ended', function () {
          videoStatic[4].fadeIn();

          if (screenSize == "desktop") {
            fullpage_api.moveSectionDown();
          }
        });
      }
    }

    function videoFourPause() {
      videoStatic[4].fadeIn();
      videoPlayer[4].setCurrentTime(0).then(function (seconds) {
        videoPlayer[4].pause();
      });
    }

    function checkAnimations() {
      setTimeout(function () {
        var CurrentSlide = fullpage_api.getActiveSection().index; //hamburgerColour(CurrentSlide, "load");

        switch (CurrentSlide) {
          case 2:
            videoTwoPlay();
            break;

          case 3:
            videoTwoPause();
            break;

          case 5:
            videoThreePlay();
            break;

          case 9:
            videoFourPlay();
            break;

          case 10:
            videoFourPause();
            break;

          default:
            break;
        }
      }, 500);
    }

    checkAnimations();

    if ($('#group-home').length > 0) {
      var purposeBtn = $(".purposeBtn a");
      purposeBtn.on("click", function () {
        if ($('.header').hasClass('is-active')) {
          $('.header').removeClass('is-active');
        }

        scrolling = 1;
        setTimeout(function () {
          scrolling = 0;
        }, 2000);
        return false;
      });
      var principlesBtn = $(".principlesBtn a");
      principlesBtn.on("click", function () {
        if ($('.header').hasClass('is-active')) {
          $('.header').removeClass('is-active');
        }

        scrolling = 1;
        setTimeout(function () {
          scrolling = 0;
        }, 2000);
        return false;
      });
      var processBtn = $(".processBtn a");
      processBtn.on("click", function () {
        if ($('.header').hasClass('is-active')) {
          $('.header').removeClass('is-active');
        }

        scrolling = 1;
        setTimeout(function () {
          scrolling = 0;
        }, 2000);
        return false;
      });
      var placesBtn = $(".placesBtn a");
      placesBtn.on("click", function () {
        if ($('.header').hasClass('is-active')) {
          $('.header').removeClass('is-active');
        }

        scrolling = 1;
        setTimeout(function () {
          scrolling = 0;
        }, 2000);
        return false;
      });
      var transitionArrows = $('.bottom-arrow'),
          nextPage;
      transitionArrows.on('click', function () {
        nextPage = $(this).data('advance-slide');
        fullpage_api.moveTo(nextPage);
      });
    }
  }
});

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

;